export const darkBlueTheme = {
  gradient: 'linear-gradient(to right, #141E30, #243B55)',
  colors: {
    logo: '#ffffff',
    background: 'rgb(16, 42, 67)',
    cardBG: 'rgb(33 57 82)',
    tagBG: '#CEEDFF',
    border: '#718096',
    text: '#fff',
    subtext: '#fff',
    color: '#fff',
    heading: '#fff',
    icon: '#486581',
    link: '#F8CCFF',
    career: {
      tagBG: 'rgba(237, 242, 247, 0.16)',
      text: '#fff',
      subtext: '#fff',
      logoBG: '#f0f8ff'
    },
    skills: {
      color: '#fff',
      border: '#4299E1',
      bg: '#427a9e'
    },
    accent: '#ff7a4d',
    accentBG: 'rgba(252, 74, 26, 0.16)',
    accentBorder: 'rgba(255, 122, 77, 0.4)'
  }
};

export const darkGreenTheme = {
  gradient: 'linear-gradient(to right, #0B1F1A, #173B32)',
  colors: {
    logo: '#F7FAF9',
    background: '#0B1F1A',
    cardBG: '#17352E',
    tagBG: '#CEEDFF',
    border: '#4F6F66',
    text: '#F7FAF9',
    subtext: '#D7E3DF',
    color: '#F7FAF9',
    heading: '#F7FAF9',
    icon: '#76958C',
    link: '#F8CCFF',
    career: {
      tagBG: 'rgba(237, 242, 247, 0.16)',
      text: '#F7FAF9',
      subtext: '#D7E3DF',
      logoBG: '#f0f8ff'
    },
    skills: {
      color: '#F7FAF9',
      border: '#4F6F66',
      bg: '#285247'
    },
    accent: '#ff7a4d',
    accentBG: 'rgba(252, 74, 26, 0.16)',
    accentBorder: 'rgba(255, 122, 77, 0.4)'
  }
};

export const activeDarkTheme = darkGreenTheme;
